export const customStyles = {
  enterRight: 'nothing',
  enterLeft: 'nothing',
  exitRight: 'nothing',
  exitLeft: 'nothing',
  intro: 'nothing',
};
